import { useCheckoutStore } from '@stores/checkout'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface ButtonBackReturn {
  show: ComputedRef<boolean>
  setSubmit: () => void
}
export const useButtonBack = (): ButtonBackReturn => {
  const name = 'btn_checkout_back'

  const checkoutStore = useCheckoutStore()

  const show = computed(() => checkoutStore.isOrderId)

  const setSubmit = (): void => {
    trackEvent(amplitudeConfig.events.clickBackButton, {
      name,
      ...checkoutStore.getEventProps,
    })

    if (window?.history?.length > 1) {
      window.history.go(-2)
    }
  }

  return {
    show,
    setSubmit,
  }
}
